import React, {memo} from "react";

export const IconAccount = memo(({color, height, width, addClass}) => {
  return (
    <svg
      width={width || "16"}
      height={height || "17"}
      viewBox="0 0 16 17"
      fill="none"
      className={addClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 0.55481H1.5C0.673 0.55481 0 1.22781 0 2.05481V15.0548C0 15.8818 0.673 16.5548 1.5 16.5548H14.5C15.327 16.5548 16 15.8818 16 15.0548V2.05481C16 1.22781 15.327 0.55481 14.5 0.55481ZM15 2.05481V5.55481H11V1.55481H14.5C14.776 1.55481 15 1.77881 15 2.05481ZM6 10.5548V6.55481H10V10.5548H6ZM10 11.5548V15.5548H6V11.5548H10ZM5 10.5548H1V6.55481H5V10.5548ZM6 5.55481V1.55481H10V5.55481H6ZM11 6.55481H15V10.5548H11V6.55481ZM1.5 1.55481H5V5.55481H1V2.05481C1 1.77881 1.224 1.55481 1.5 1.55481ZM1 15.0548V11.5548H5V15.5548H1.5C1.224 15.5548 1 15.3308 1 15.0548ZM14.5 15.5548H11V11.5548H15V15.0548C15 15.3308 14.776 15.5548 14.5 15.5548Z"
        fill={color || "#000"}
      />
    </svg>
  );
});
